<div class="relative bg-[var(--white)] p-12 max-w-md mx-auto rounded-xl shadow-lg">
  <div class="">
    <h2 class="text-[var(--dark-orange)] font-normal text-[28px]/[33px] text-left w-full">{{ data.title }}</h2>
    <p *ngIf="data.visitorName" class="text-[var(--black)] font-semibold text-[16px] mt-1">{{ data.visitorName }}</p>
    <button 
      class="absolute top-[16px] right-[16px] border border-[3px] border-[var(--dark-orange)] rounded-full p-1" 
      (click)="closeModal()"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        class="h-3 w-3" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="var(--dark-orange)"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="6" 
          d="M6 18L18 6M6 6l12 12" 
        />
      </svg>
    </button>
  </div>

  <div class="flex justify-center">
    <div class="p-4 bg-[var(--white)] rounded-xl">
      <img 
        [src]="data.qrCode" 
        alt="drinkhopping" 
        class="w-48 h-48 rounded-lg" 
      />
    </div>
  </div>

  <div class="text-center space-y-2">
    <fa-icon class="text-sm uppercase" [icon]="faCalendarAlt" size="lg"></fa-icon>
    <div class="text-[17px]/[23px] font-normal">
      <p class="">{{ 'qrModal.validUntil' | translate }}</p>
      <p class="font-bold">{{ data.eventDate | date }}</p>
    </div>
    <div class="mt-2">
      <p class="text-xs text-[var(--dark-grey)]">
        <span class="font-semibold">{{ 'qrModal.disclaimer' | translate }}</span><br>
        {{ 'qrModal.disclaimerFull' | translate }}
      </p>
    </div>
  </div>

  <div *ngIf="data.qrId && (isIos || isAndroid)" class="mt-5 flex justify-center">
    <button *ngIf="isIos" (click)="addToAppleWallet()" [disabled]="isLoadingWallet"
      class="flex items-center gap-3 bg-black text-white rounded-xl px-5 py-3 disabled:opacity-60 transition-opacity">
      <img src="assets/svg-png/apple-wallet.png" alt="Apple Wallet" class="h-9 w-9 object-contain"/>
      <span class="text-left leading-tight">
        <span class="block text-[11px] font-normal opacity-80">{{ 'qrModal.addTo' | translate }}</span>
        <span class="block text-[17px] font-semibold">{{ 'qrModal.addToAppleWallet' | translate }}</span>
      </span>
    </button>

    <button *ngIf="isAndroid" (click)="addToGoogleWallet()" [disabled]="isLoadingWallet"
      class="flex items-center gap-3 bg-black text-white rounded-xl px-5 py-3 disabled:opacity-60 transition-opacity">
      <img src="assets/svg-png/google-wallet.png" alt="Google Wallet" class="h-9 w-9 object-contain"/>
      <span class="text-left leading-tight">
        <span class="block text-[11px] font-normal opacity-80">{{ 'qrModal.addTo' | translate }}</span>
        <span class="block text-[17px] font-semibold">{{ 'qrModal.addToGoogleWallet' | translate }}</span>
      </span>
    </button>
  </div>
</div>